import * as React from 'react';

import {CopyButton} from 'shells/button/copy-button/copy-button';
import {HtmlLinkIcon} from 'shells/icon/svg/html-link-icon';
import {PageHeader} from 'shells/page-header/page-header';

import {PREVIEW_TYPE} from '../../../chat-preview/consts';

import {appHistory} from '../../../../history';

import {ChatPreviewWrapper} from '../chat-preview-wrapper';
import {useGetContextDocuments} from '../graphql/hooks';
import {useGetChatSettings} from '../graphql/hooks/use-get-chat-settings';

import styles from './test-chatbot.module.css';

export function TestChatbot() {
    const {primaryContextDocument} = useGetContextDocuments(true);
    const {chatSettings} = useGetChatSettings();

    if (!primaryContextDocument || !primaryContextDocument.shareablePreviewUrl) {
        return <div className='full-width background-white border-top-left-8' />;
    }

    return (
        <div className='flex flex-dir-col flex-grow overflow-auto full-height background-offwhite border-top-left-8'>
            <PageHeader
                title=''
                backButton={{
                    onClick: () => {
                        appHistory.goBack();
                    },
                    text: 'Back to setup',
                }}
                actionButtons={
                    <CopyButton
                        size='big'
                        contentToCopy={primaryContextDocument.shareablePreviewUrl}
                        icon={HtmlLinkIcon}
                        text={{
                            button: 'Copy link',
                            copiedButton: 'Copy link',
                            tooltip: 'Copy link to preview',
                            copiedTooltip: 'Copied!',
                        }}
                    />
                }
            />
            {chatSettings && chatSettings.embedScript && (
                <div className={styles['preview-container']}>
                    <ChatPreviewWrapper
                        previewWebsiteUrl={primaryContextDocument.previewUrl}
                        previewType={PREVIEW_TYPE.TEST}
                        embedScript={chatSettings.embedScript}
                        instanceId={NutshellFrontendSettings.instanceId}
                        canEmbedInIframe={
                            primaryContextDocument && primaryContextDocument.canEmbedIframe
                        }
                        isDevelopment={NutClientConfig.isDevelopment}
                    />
                </div>
            )}
        </div>
    );
}
